import { t } from '../../../utils/i18n';

/**
 * Manage-link card-on-file gate. When the API answers 402 `card_required`
 * (channel collects a card at booking, patient has none saved), render an
 * inline notice with the signed "add your card" link next to the button the
 * patient just pressed; they add the card in a new tab and press the button
 * again. Returns false when the error is anything else so the caller falls
 * back to its generic toast.
 */
export function showCardRequiredNotice(error, anchorButton) {
    const data = error?.response?.status === 402 ? error.response.data : null;
    if (!data || !data.card_required) return false;

    const host = anchorButton?.parentElement || document.body;
    let notice = host.querySelector('.card-required-notice');
    if (!notice) {
        notice = document.createElement('div');
        notice.className = 'card-required-notice';
        notice.setAttribute('role', 'alert');
        if (anchorButton) {
            host.insertBefore(notice, anchorButton);
        } else {
            host.appendChild(notice);
        }
    }

    notice.textContent = '';
    const text = document.createElement('p');
    text.textContent = data.message || t('card_required_message');
    notice.appendChild(text);

    if (data.card_link) {
        const link = document.createElement('a');
        link.href = data.card_link;
        link.target = '_blank';
        link.rel = 'noopener';
        link.className = 'card-required-notice__link';
        link.textContent = t('card_required_add');
        notice.appendChild(link);
    }

    const hint = document.createElement('p');
    hint.className = 'card-required-notice__hint';
    hint.textContent = t('card_required_retry');
    notice.appendChild(hint);

    return true;
}
